import { Component, OnInit, ViewChild, ViewContainerRef, Renderer2, ElementRef, HostListener } from '@angular/core';
import { encapsulation } from '../../components/encapsulation';
import { UBXModalService } from '../../services';
import { UBXModal } from '../../models';

@Component({
    selector: 'ubx-modal',
    templateUrl: './modal.component.html',
    host: { class: 'ubx-modal flx f-jc:c f-ai:c p:fx cvr:a pe:n zi:100' },
    encapsulation
})
export class UBXModalComponent implements OnInit {
    @ViewChild('vcr', { read: ViewContainerRef }) vcr: ViewContainerRef;

    constructor(
        private renderer: Renderer2,
        private el: ElementRef,
        private modalService: UBXModalService,
    ) { }

    ngOnInit() {
        this.getModal();
    }

    getModal() {
        this.modalService.getModals().subscribe((modal: UBXModal) => {
            if (!modal) {
                this.clearModal();
                return;
            }
            this.createModal(modal);
        });
    }

    private createModal(modal: UBXModal) {
        this.appendClass('open');
        this.vcr.createEmbeddedView(modal.template);
    }

    private clearModal() {
        this.removeClass('open');
        this.vcr.clear();
    }

    private appendClass(name: string) {
        this.renderer.addClass(this.el.nativeElement, name);
    }
    private removeClass(name: string) {
        this.renderer.removeClass(this.el.nativeElement, name);
    }

    @HostListener('click', ['$event']) onClick(event: any) {
        const bgClick = event.target.localName.indexOf('ubx-modal') !== -1;
        if (bgClick) {
            this.clearModal();
        }
    }
}
